import { render, staticRenderFns } from "./ProjectMembers.vue?vue&type=template&id=6e85a606&scoped=true"
import script from "./ProjectMembers.vue?vue&type=script&lang=js"
export * from "./ProjectMembers.vue?vue&type=script&lang=js"
import style0 from "./ProjectMembers.vue?vue&type=style&index=0&id=6e85a606&prod&scoped=true&lang=css"
import style1 from "./ProjectMembers.vue?vue&type=style&index=1&id=6e85a606&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e85a606",
  null
  
)

export default component.exports